export default async (value) => typeof value === 'boolean'
